import ToggleSwitch from 'components/inputs/toggle-switch';

type ConditioningToggleProps = {
  spaceId: string;
  value: boolean;
  onChange: (value: boolean) => void;
  capturePointer?: boolean;
};

export default function ConditioningToggle({
  spaceId,
  value,
  onChange,
  capturePointer = false
}: ConditioningToggleProps) {
  return (
    <div
      className={capturePointer ? 'pointer-events-auto mt-2' : 'mt-2'}
      id={`ductwork-toggle-${spaceId}`}
      onClick={capturePointer ? (e) => e.stopPropagation() : undefined}
      onMouseDown={capturePointer ? (e) => e.stopPropagation() : undefined}
    >
      <ToggleSwitch value={value} onChange={onChange} offColor='red' />
    </div>
  );
}
